<template>
	<div>
		<div class="row dashboard-info-widgets">
			<div class="col-md-3 d-flex">
				<vuestic-widget class="info-widget component-card">
					<div class="info-widget-inner">
						<div class="stats">
							<div class="stats-number">
								<i class="ion ion-md-arrow-up green-arrow stats-icon"></i>
								{{ novosAlunos }}
							</div>
							<div class="stats-title">Novos Alunos</div>
						</div>
					</div>
				</vuestic-widget>
			</div>

			<div class="col-md-3 d-flex">
				<vuestic-widget class="info-widget component-card">
					<div class="info-widget-inner">
						<div class="stats">
							<div class="stats-number">
								<i class="ion ion-md-arrow-up green-arrow stats-icon"></i>
								{{ novosBoletos }}
							</div>
							<div class="stats-title">Novos Boletos</div>
						</div>
					</div>
				</vuestic-widget>
			</div>

			<div class="col-md-3 d-flex">
				<vuestic-widget class="info-widget component-card brand-danger">
					<div class="info-widget-inner">
						<div class="info-widget-inner has-chart">
							<div class="stats">
								<div class="stats-number">
									{{ presencas }}
								</div>
								<!-- <div class="stats-title">Presenças Hoje</div> -->
							</div>
							<div class="chart-container">
								<vuestic-progress-bar type="circle" :value="porcentagem" theme="White" backgroundTheme="Danger"/>
							</div>
						</div>
					</div>
				</vuestic-widget>
			</div>

			<div class="col-md-3 d-flex">
				<vuestic-widget class="info-widget component-card">
					<div class="info-widget-inner">
						<div class="stats">
							<div class="stats-number">
								<i class="ion ion-md-people stats-icon icon-wide"></i>
								{{ totalAlunos }}
							</div>
							<div class="stats-title">Total de Alunos</div>
						</div>
					</div>
				</vuestic-widget>
			</div>
		</div>
	</div>

</template>

<script>
	import urlApi from '../../router/urlApi'

	export default {
		name: 'dashboard-info-widgets',
		data(){
			return {
				novosAlunos: 0,
				novosBoletos: 0,
				concludentes: 0,
				presencas: 0,
				porcentagem: 0,
				reagendamentos: 0,
				totalAlunos: 0,
			}
		},
		mounted(){
			this.$http.get(urlApi + '/alunos/ultimos').then(function(response){
				this.novosAlunos = response.data.dados;
			})
			.then(this.$http.get(urlApi + '/alunos/ultimosBoletos').then(function(response){
				this.novosBoletos = response.data.dados;
			}))
			.then(this.$http.get(urlApi + '/alunos/quantidade').then(function(response){
				this.totalAlunos = response.data.dados;
			}))
		}
	}
</script>

<style lang="scss" scoped>
	.component-container {
		height: auto;
	}

	.component-card {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.stats-number, .stats-title {
		line-height: 1;
	}

	.info-widget-inner {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		position: relative;
		width: 100%;

		&.has-chart {
			justify-content: space-between;
		}

		.stats {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			height: 100%;
		}
	}

	.stats-number {
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		font-size: 2.625rem;
		margin-bottom: 0.5rem;

		.stats-icon {
			font-size: 1.5625rem;
			position: absolute;
			top: 0.625rem;
			left: -1.25rem;

			&.icon-wide {
				left: -1.875rem;
			}
		}
	}

	.green-arrow{
		color: rgb(30, 230, 30);
	}
</style>